import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useEnterSubmit } from "../hooks/useEnterSubmit";
import { vsOpsApi } from "./api";

function VsOpsLoginPage() {
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState("");
  const [step, setStep] = useState("login");
  const [error, setError] = useState("");
  const [checkingSession, setCheckingSession] = useState(true);
  const [loading, setLoading] = useState(false);

  const canVerify = step === "2fa" && Boolean(token.trim()) && !loading;
  useEnterSubmit(formRef, canVerify);

  useEffect(() => {
    vsOpsApi
      .getSession()
      .then((session) => {
        if (session.authenticated && !session.pending2fa) {
          navigate("/vs-ops/sales", { replace: true });
        } else if (session.authenticated && session.pending2fa) {
          setStep("2fa");
        }
      })
      .catch(() => {})
      .finally(() => setCheckingSession(false));
  }, [navigate]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const result = await vsOpsApi.login(username.trim(), password);
      if (result.requires2fa) {
        setStep("2fa");
      } else {
        navigate("/vs-ops/sales", { replace: true });
      }
    } catch (loginError) {
      setError(loginError.message || "Ошибка входа");
    } finally {
      setLoading(false);
    }
  };

  const handle2fa = async (event) => {
    event.preventDefault();
    if (!canVerify) return;
    setError("");
    setLoading(true);
    try {
      await vsOpsApi.verify2fa(token.trim());
      navigate("/vs-ops/sales", { replace: true });
    } catch (verifyError) {
      setError(verifyError.message || "Неверный код");
    } finally {
      setLoading(false);
    }
  };

  if (checkingSession) {
    return (
      <div className="vs-ops-page vs-ops-login-page">
        <p className="vs-ops-muted">Проверка сессии…</p>
      </div>
    );
  }

  return (
    <div className="vs-ops-page vs-ops-login-page">
      <form
        ref={formRef}
        className="vs-ops-login-card"
        onSubmit={step === "2fa" ? handle2fa : handleLogin}
      >
        <h1 className="vs-ops-login-title">Visoria Ops</h1>
        <p className="vs-ops-muted">Вход в панель продаж других магазинов</p>

        {step === "login" ? (
          <>
            <label className="vs-ops-field">
              <span>Логин</span>
              <input
                type="text"
                autoComplete="username"
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                autoFocus
                required
              />
            </label>
            <label className="vs-ops-field">
              <span>Пароль</span>
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </label>
          </>
        ) : (
          <label className="vs-ops-field">
            <span>Код 2FA</span>
            <input
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              value={token}
              onChange={(event) => setToken(event.target.value)}
              placeholder="000000"
              autoFocus
              required
            />
          </label>
        )}

        {error ? <p className="vs-ops-error">{error}</p> : null}

        <button type="submit" className="vs-ops-btn" disabled={loading}>
          {loading ? "Подождите…" : step === "2fa" ? "Подтвердить" : "Войти"}
        </button>
      </form>
    </div>
  );
}

export function VsOpsRequireAuth({ children }) {
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    vsOpsApi
      .getSession()
      .then((session) => {
        setState({
          loading: false,
          ok: Boolean(session.authenticated && !session.pending2fa),
          pending2fa: Boolean(session.pending2fa),
        });
      })
      .catch(() => setState({ loading: false, ok: false }));
  }, []);

  if (state.loading) {
    return (
      <div className="vs-ops-page vs-ops-login-page">
        <p className="vs-ops-muted">Загрузка…</p>
      </div>
    );
  }

  if (state.pending2fa) {
    return <Navigate to="/vs-ops/login" replace />;
  }

  if (!state.ok) {
    return <Navigate to="/vs-ops/login" replace />;
  }

  return children;
}

export default VsOpsLoginPage;
